import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { isBoolean } from 'lodash-es'

import { HTML_LINK_TARGET } from '../constants/html'
import { ROUTE_PATH_LIST_AUTH, WEBAPP_ROUTE_PREFIX } from '../constants/route'
import { LOCAL_STORAGE_NAME_TOKEN } from '../constants/storage'
import { getRedirectPathname } from '../utils/link'
import { getWebappLinkPrefix } from '../utils/route'
import { removeStorageItem } from '../utils/storage'

import { useAppAvailable } from './useAppAvailable'
import { useInitData } from './useInitData'

export function useLogin() {
  const navigate = useNavigate()
  const { pathname, search } = useLocation()

  const { authorized } = useInitData()
  const appAvailable = useAppAvailable()

  const redirectPathname = getRedirectPathname(pathname, search)
  const loginUrl = ROUTE_PATH_LIST_AUTH.login(redirectPathname)

  useEffect(() => {
    if (!authorized && isBoolean(appAvailable)) {
      removeStorageItem(LOCAL_STORAGE_NAME_TOKEN)

      if (appAvailable) {
        navigate(loginUrl, { replace: true })
      } else if (
        !loginUrl.includes(
          `${WEBAPP_ROUTE_PREFIX}${ROUTE_PATH_LIST_AUTH.login()}`
        )
      ) {
        window.open(getWebappLinkPrefix(loginUrl), HTML_LINK_TARGET.self)
      }
    }
  }, [appAvailable, authorized])
}
